// ONLYOFFICE replaces its target element with an iframe. React must own only the
// stable outer host, never the placeholder that the SDK replaces.
export function mountOnlyOfficeEditor(host, DocEditor, config) {
  if (!host) throw new Error('The document editor container is not available.');
  const placeholder = document.createElement('div');
  placeholder.id = 'onlyoffice-presentation';
  host.replaceChildren(placeholder);
  try {
    return new DocEditor(placeholder.id, config);
  } catch (error) {
    host.replaceChildren();
    throw error;
  }
}

export function clearOnlyOfficeHost(host) {
  if (host) host.replaceChildren();
}
